/**
 * Created with IntelliJ IDEA.
 * User: nzamuruev
 * Date: 05.08.13
 * Time: 10:20
 * To change this template use File | Settings | File Templates.
 */


export class FirstInstancePlaytimeStateVO {
    public timeDelay: number;
    public eventState: string;

    constructor(time: number, state: string) {
        this.timeDelay = time;
        this.eventState = state;
    }
}

